import KendoDatePickerViewModelBase from '@/Components/KendoDateTimePicker/ViewModels/KendoDatePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import ResourceManager from '@/Management/ResourceManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class KendoDateAndTimePickerViewModel extends KendoDatePickerViewModelBase {

    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    /**
     * Das ViewModel für den Link zum Auwählen eines Datums
     */
    public linkDate: LinkViewModelT;

    /**
     * Das ViewModel für den Link zum Auwählen einer Uhrzeit
     */
    public linkTime: LinkViewModelT;

    public constructor(params: any) {
        super(params);

        this.linkDate = this.createDateLinkViewModel();
        this.linkTime = this.createTimeLinkViewModel();
    }

    /**
     * @override
     * @inheritdoc 
     * @param date
     */
    protected parseToDotNetString(date: Date): string {
        return DateHelper.toDotNetDateTimeString(date);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return `${language.datePattern} ${language.timePattern}`;
        });
    }

    private createDateLinkViewModel(): LinkViewModelT {
        return new this.LinkViewModel({
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.PICKER,
                parentLocator: this.locator,
                locator: 'link_date.image',
                alternativeText: new this.LabelViewModel({
                    ergName: 'FACTORY_DATEPICKER'
                })
            }),
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: 'link_date',
            isVisible: this.isEnabled,
            isToolBarLink: true,
            tooltip: new this.LabelViewModel({
                ergName: 'FACTORY_DATEPICKER'
            })
        });
    }

    private createTimeLinkViewModel(): LinkViewModelT {
        return new this.LinkViewModel({
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.TIMEPICKER,
                parentLocator: this.locator,
                locator: 'link_time.image',
                alternativeText: new this.LabelViewModel({
                    ergName: 'FACTORY_TIMEPICKER'
                })
            }),
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: 'link_time',
            isVisible: this.isEnabled,
            isToolBarLink: true,
            tooltip: new this.LabelViewModel({
                ergName: 'FACTORY_TIMEPICKER'
            })
        });
    }
}

ComponentManager.setViewModel('KendoDateAndTimePickerViewModel', KendoDateAndTimePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');